let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dWBnF")).then(() => parcelRequire('1rbp7'));